import { createRoute } from '@tanstack/react-router'
import { rootRoute } from './__root'
import { useAuth } from '../auth/useAuth'

export const loginRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/login',
  component: LoginPage,
})

function LoginPage() {
  const { login } = useAuth()

  return (
    <div data-testid="login-page" className="flex items-center justify-center min-h-screen">
      <div className="w-full max-w-sm p-8 bg-gray-900 rounded-lg border border-gray-800">
        <h1 className="text-2xl font-bold text-center mb-2">Droid Instinct</h1>
        <p className="text-gray-400 text-center text-sm mb-6">Sign in to continue</p>
        <button
          data-testid="login-button"
          className="w-full py-2.5 px-4 bg-blue-600 hover:bg-blue-500 text-white font-medium rounded-md transition-colors"
          onClick={login}
        >
          Sign in with Authentik
        </button>
      </div>
    </div>
  )
}
